module.exports = __webpack_public_path__ + "img/herpsoc.0fa205d3.png";